<template>
  <div>
    <div class="title_h1">発注詳細</div>
    <vab-query-form
      ref="queryForm"
      :model="queryForm"
      :rules="rules"
      size="mini"
      label-width="98px"
      @search="fetchData"
    >
      <vab-row :gutter="24">
        <vab-col :lg="8" :xl="8" :md="12">
          <vab-date-picker
            type="month"
            placeholder="開始月"
            label="作業年月"
            class="width_140"
            value-format="yyyyMM"
            format="yyyy/MM"
            prop="workYm"
            validate="required"
            :clearable="false"
          />
        </vab-col>
        <!-- 建物 -->
        <vab-col :lg="8" :xl="8" :md="12">
          <el-row type="flex">
            <el-col :span="24">
              <vab-input label="建物" prop="blgsnmkj" />
            </el-col>
          </el-row>
        </vab-col>
        <!-- 商品明細 -->
        <vab-col :lg="8" :xl="8" :md="12">
          <MitmdtlpNew
            ref="itemDetailCdRef"
            prop="itemDetailCd"
            :componentcd.sync="queryForm.itemDetailCd"
            :multi-select="false"
            :span1="6"
            :span2="18"
            :clear-validate="true"
            @clearOtherData="clearOtherData"
          />
        </vab-col>
        <!-- TODO 多选修改字段 后加List -->
        <vab-col :lg="8" :xl="8" :md="12">
          <vab-select
            ref="workSpecRef"
            label="点検仕様"
            prop="workSpecCdList"
            :data-items="workSpecCdList"
            label-id="itmgkmnm"
            value-id="itmgkmcd"
            collapse-tags
            :disabled="workSpecCdDisabled"
            placeholder=""
            multiple
            clearable
          />
        </vab-col>
        <vab-collapse title="詳細検索を表示">
          <!-- TODO 多选修改字段 后加List -->
          <vab-col :lg="8" :xl="8" :md="12">
            <vab-select
              ref="groupRef"
              label="グループ"
              prop="groupList"
              filter="groupValue"
              placeholder="選択されていません"
              collapse-tags
              multiple
              clearable
            />
          </vab-col>
          <vab-col :lg="8" :xl="8" :md="12">
            <vab-select
              label="日程調整不要"
              prop="adjustUnnecessaryFlg"
              :data-items="adjustUnnecessaryFlg"
              label-id="text"
              value-id="value"
              clearable
            />
          </vab-col>
        </vab-collapse>
      </vab-row>
    </vab-query-form>
    <vab-form ref="form" :model="formObj" :rules="rulesObj">
      <el-row>
        <el-col>
          <vab-table
            ref="table"
            api-url="/api/purchaseOrderDetailRc/queryOrderDetailList"
            :columns="columns"
            :right-buttons="rightButtons"
            :query-params="{
              ...queryForm,
              sidx: 'workNo,purchaseOrderDetailRcId',
              sort: 'desc,desc',
            }"
            primary-key="purchaseOrderDetailRcId"
            :span="12"
            :enable-init="reloadPage"
          >
            <template #blgsnmkj="{ row }">
              <div class="blgsnmkj_class">
                <svg-icon class="svg_icon" icon-class="select_work" />
                <el-link type="primary" @click="openBlgsnmkj(row)">
                  {{ row.blgsnmkj }}
                </el-link>
              </div>
            </template>
            <template #dateLimitContent="{ row }">
              <div class="flex_colum">
                <div class="pre_wrap">
                  {{
                    getFieldValue(
                      'dateLimitContentCanText',
                      row.weekdayConditionSpecify
                    )
                  }}
                </div>
                <div>
                  {{
                    getFieldValue(
                      'dateLimitContentCannotText',
                      row.weekdayConditionSpecify
                    )
                  }}
                </div>
              </div>
            </template>
          </vab-table>
        </el-col>
      </el-row>
    </vab-form>
    <div class="flex_space mg12">
      <vab-button :btn-list="makeList" />
    </div>
    <Buildings ref="building" />
  </div>
</template>

<script lang="jsx">
  import {
    queryBuildingInformation,
    getFoundSelfData,
  } from '@/api/rc/jobReservation'
  import format from 'string-format'
  import reload from '@/utils/reload'
  export default {
    name: 'PWR01G02',
    extends: reload,
    data() {
      return {
        workSpecCdDisabled: true,
        workSpecCdList: [],
        formObj: {},
        rulesObj: {},
        rules: {},
        queryForm: {
          adjustUnnecessaryFlg: '0',
          itemDetailCd: null,
          workYm: this.$dayjs().format('YYYYMM'),
        },
        goodsLists: [],
        form: {},
        columns: [
          {
            label: '発注NO連番',
            'min-width': 140,
            prop: 'acceptOrderNoSeq',
            fixed: 'left',
          },
          {
            label: '作業No(代表)',
            'min-width': 140,
            prop: 'workNo',
            fixed: 'left',
          },
          {
            label: '建物CD',
            'min-width': 120,
            prop: 'buildingCd',
          },
          {
            label: '建物',
            'min-width': 240,
            sortable: false,
            slotScope: 'blgsnmkj',
          },
          {
            label: '商品明細CD',
            'min-width': 120,
            prop: 'itemDetailCd',
          },
          {
            label: '商品明細',
            'min-width': 140,
            prop: 'itmdtlnm',
          },
          {
            label: '点検仕様',
            'min-width': 160,
            prop: 'workSpecName',
          },
          {
            label: '日程調整不要',
            'min-width': 140,
            prop: 'adjustUnnecessaryFlg',
            formatter: (row, column, cellValue) => {
              return this.getEnumTextChange(
                cellValue,
                this.$divisions.unnecessaryFlagEnum
              )
            },
          },
          {
            label: 'FM不在の場合',
            'min-width': 140,
            prop: 'weekdayConditionSpecify.fmAbsentCheckableFlg',
            sortable: false,
            formatter: (row, column, cellValue) => {
              return this.getEnumTextChange(
                cellValue,
                this.$divisions.checkableFlgEnum
              )
            },
          },
          {
            label: '要日程調整',
            'min-width': 140,
            sortable: false,
            prop: 'weekdayConditionSpecify.needAdjustFlg',
            formatter: (row, column, cellValue) => {
              return this.getEnumTextChange(
                cellValue,
                this.$divisions.necessaryFlagEnum
              )
            },
          },
          {
            label: '曜日指定',
            sortable: false,
            'min-width': 240,
            prop: 'weekdayConditionSpecify.weekdayLimitContentText',
          },
          {
            label: '日付指定',
            sortable: false,
            'min-width': 240,
            slotScope: 'dateLimitContent',
          },
          {
            label: '時間指定',
            'min-width': 140,
            sortable: false,
            prop: 'weekdayConditionSpecify.timeLimitContentText',
          },
          {
            label: 'お知らせ文',
            sortable: false,
            'min-width': 240,
            prop: 'weekdayConditionSpecify.notifyText',
          },
          {
            label: '報告書',
            sortable: false,
            'min-width': 240,
            prop: 'weekdayConditionSpecify.reportText',
          },
          {
            label: '発注コメント',
            'min-width': 240,
            prop: 'purchaseOrderDetailComment',
          },
          {
            label: '自由コメント',
            sortable: false,
            'min-width': 240,
            prop: 'weekdayConditionSpecify.freeComment',
          },
          {
            label: '協力会社CD',
            'min-width': 160,
            sortable: false,
            formatter: (row) => {
              return row.checkOrganizationCd
                ? row.checkOrganizationCd
                : row.bcnfrkjCd
            },
          },
          {
            label: '協力会社',
            'min-width': 240,
            sortable: false,
            formatter: (row) => {
              return row.checkOrganizationCd ? row.bcnfrkj : row.supplieName
            },
          },
          {
            label: '管理形態',
            'min-width': 140,
            prop: 'mngfrm',
            formatter: (row, column, cellValue) => {
              return this.getEnumText(cellValue, this.$divisions.manageFormEnum)
            },
          },
          {
            label: '月間回数',
            'min-width': 100,
            prop: 'monthFreq',
          },
          {
            label: '発注金額',
            'min-width': 120,
            align: 'right',
            prop: 'costPrice',
            type: 'number',
          },
          {
            label: 'グループ',
            'min-width': 120,
            prop: 'groupValue',
            formatter: (row, column, cellValue) => {
              return this.getEnumText(cellValue, this.$divisions.groupValueEnum)
            },
          },
          {
            // 按钮
            type: 'actions',
            label: '操作',
            fixed: 'right',
            'min-width': 120,
            disableCheck: true,
            info: '詳細',
            svg: 'right_line',
            click: (row) => {
              this.$routerPush({
                name: 'PWR01G03',
                query: {
                  purchaseOrderDetailRcId: row.purchaseOrderDetailRcId,
                  fromRoute: this.$route.name,
                },
              })
            },
          },
        ],
        rightButtons: [
          {
            type: 'slot',
            hidden: false,
            render: () => {
              return (
                <div
                  class="tzx_box right_btn_text"
                  on={{
                    click: (command) => {
                      this.goNote(command)
                    },
                  }}
                >
                  <svg-icon icon-class="transfer_3_line" class="transfer_svg" />
                  <span>作業予定に切り替え</span>
                </div>
              )
            },
          },
        ],
        makeList: [
          {
            name: 'Excel出力',
            icon: 'xls_fill',
            type: 'plain',
            hidden: false,
            defaultColor: '#0060C2',
            click: this.handleDownload,
          },
        ],
        adjustUnnecessaryFlg: [
          {
            code: this.$divisions.unnecessaryFlagEnum.enum_1,
            value: '0',
            text: '日程調整不要を含まない',
          },
          {
            code: this.$divisions.unnecessaryFlagEnum.enum_blank,
            value: '1',
            text: '日程調整不要を含む',
          },
        ],
      }
    },
    computed: {
      searchData() {
        return this.$store.getters['notify/searchData']
      },
    },
    watch: {
      async 'queryForm.itemDetailCd'(cd) {
        if (this.$baseLodash.isEmpty(cd)) {
          this.workSpecCdDisabled = true
        } else {
          this.workSpecCdDisabled = false
          this.workSpecCdList = await getFoundSelfData({
            itmdtlcd: this.queryForm.itemDetailCd,
          })
        }
      },
    },
    beforeDestroy() {
      let data = JSON.parse(this.searchData)
      if (!this.$baseLodash.isEmpty(data) && data[this.$route.name]) {
        data[this.$route.name] = []
        this.$store.dispatch('notify/setPageSearchData', JSON.stringify(data))
      }
    },
    mounted() {
      if (this.$route?.query?.goNote === '1') {
        this.$refs['queryForm'].cancel()
        if (this.$baseLodash.isEmpty(this.queryForm.workYm)) {
          this.queryForm.workYm = this.$dayjs().format('YYYYMM')
        }
        this.initQuery()
      }
    },
    methods: {
      // 伝参賦値です
      initQuery() {
        this.$refs['queryForm'].cancel()
        let data = JSON.parse(this.searchData)
        if (!this.$baseLodash.isEmpty(data)) {
          if (data[this.$route.name]?.length > 0) {
            this.setFormDataList(
              data[this.$route.name],
              this.$refs['queryForm']
            )
          }
        }
      },
      // 商品明細
      clearOtherData() {
        this.$refs.workSpecRef.setValue([])
        this.queryForm.workSpecCdList = []
      },
      // 作業年月チェック
      workYmValidate(rule, value, callback) {
        if (this.$baseLodash.isEmpty(this.queryForm.workYm)) {
          return callback(
            new Error(
              format(
                this.$t(`validateMessage.${this.$messageCode.E00000001.name}`),
                '作業年月'
              )
            )
          )
        }
        callback()
      },
      // ルーティングジャンプ
      goNote() {
        if (this.$baseLodash.isEmpty(this.queryForm.workYm)) {
          this.$refs['queryForm'].queryData()
          this.msgError(
            this.format(
              this.$t(`validateMessage.${this.$messageCode.E00000046.name}`),
              '作業年月'
            )
          )
          return
        }
        let formJson = this.getSearchJson(this.$refs['queryForm'])
        let data = {}
        data['PWR01G01'] = formJson
        this.$store.dispatch('notify/setPageSearchData', JSON.stringify(data))
        this.$routerPush({
          name: 'PWR01G01',
          query: { goNote: '1' },
        })
      },
      // 検索ボタン
      async fetchData() {
        if (this.$baseLodash.isEmpty(this.queryForm.workYm)) {
          this.queryForm.workYm = this.$dayjs().format('YYYYMM')
        }
        this.queryForm.workY = this.$dayjs(
          this.queryForm.workYm.toString()
        ).format('YYYY')
        this.queryForm.workM = this.$dayjs(
          this.queryForm.workYm.toString()
        ).format('MM')
        if (
          this.queryForm.workSpecCdList !== null &&
          typeof this.queryForm.workSpecCdList === 'string'
        ) {
          this.queryForm.workSpecCdList = this.queryForm.workSpecCdList.split()
        }
        await this.setQueryParamsLoad(this.queryForm)
        this.$refs.table.fetchData()
      },
      // 商品明細
      getGoodList(val) {
        const { data } = val
        this.goodsLists = [...data]
      },
      // Excel出力
      handleDownload() {
        if (this.$baseLodash.isEmpty(this.queryForm.workYm)) {
          this.$refs['queryForm'].queryData()
          this.msgError(
            this.format(
              this.$t(`validateMessage.${this.$messageCode.E00000046.name}`),
              '作業年月'
            )
          )
          return
        }
        this.downloadCommon.resource(
          '/api/purchaseOrderDetailRc/excelOutput',
          this.queryForm
        )
      },
      // 建物選択
      async openBlgsnmkj(row) {
        const dataObj = {
          buildingCd: row.buildingCd,
          sectionCd: '',
        }
        try {
          const res = await queryBuildingInformation(dataObj)
          this.$refs.building.dataList = res
        } catch (err) {
          console.error(err)
        }
        this.$refs.building.visible = true
      },
    },
  }
</script>
